(function ($) {
	var methods = {
		init: function () {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data('textareaCounter');

				if (!data) {
					var container = jQuery("<div class='textareacounter-counter-container' style='display:flex;flex-direction:column;'></div>");
					var $counter = jQuery("<div class='textareacounter-counter' style='margin-left:auto;'></div>");
					var $parent = $this.parent();
					var maxlength = parseInt($this.attr("maxlength"));
					if (isNaN(maxlength)) {
						maxlength = 2000;
						$this.attr({"maxlength": maxlength});
					}
					$parent.append(container);
					$this.appendTo(container);
					$counter.appendTo(container);
					$this.data('textareaCounter', {
						target: $this,
						couner: $counter,
						maxlength: maxlength
					});
					var left = maxlength - $this.val().length;
					$counter.html((left < 0 ? 0 : left) + "/" + maxlength);
					$this.on('input.textareaCounter', function (event) {
						event = event.originalEvent || event;
						var left = maxlength - $this.val().length;
						$counter.html((left < 0 ? 0 : left) + "/" + maxlength);
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					});
				}

			});

		},
		destroy: function () {
			return this.each(function () {
				var $this = $(this);
				$this.removeData('textareaCounter');
				$(window).unbind('.textareaCounter');
			});

		}
	};
	$.fn.textareaCounter = function (method) {
		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Метод с именем ' + method + ' не существует для jQuery.textareaCounter');
		}
	};
})(jQuery);

